import { render, staticRenderFns } from "./YellowBuildings.vue?vue&type=template&id=e3df9c32&"
import script from "./YellowBuildings.vue?vue&type=script&lang=js&"
export * from "./YellowBuildings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports